import { industryForContact } from "./industries.js";

function publicText(value, maxLength) {
  return typeof value === "string" ? value.trim().slice(0, maxLength) : "";
}

// Only these business fields may leave the private contact record. Pass a
// numeric timestamp or Firebase's serverTimestamp() sentinel as updatedAt.
export function buildPublicPreview(contact = {}, updatedAt = contact.updatedAt) {
  if (contact.previewEnabled === false) return null;
  const address = contact.address || {};
  const businessName = publicText(contact.companyName, 160);
  const preview = {
    businessName,
    shortName: businessName.split(/\s+/).slice(0, 2).join(" ").slice(0, 80),
    industry: industryForContact(contact),
    email: publicText(contact.email, 254),
    phone: publicText(contact.phone?.display, 40),
    phoneE164: publicText(contact.phone?.e164, 20),
    address: {
      streetAddress: [publicText(address.line1, 200), publicText(address.line2, 200)].filter(Boolean).join(", ").slice(0, 300),
      addressLocality: publicText(address.city, 100),
      addressRegion: publicText(address.state, 100),
      postalCode: publicText(address.postalCode, 30),
      addressCountry: publicText(address.countryCode, 2)
    },
    city: publicText(address.city, 100),
    state: publicText(address.state, 100),
    googleMapsUrl: publicText(contact.googleMapsUrl, 2048),
    updatedAt
  };
  if (Number.isFinite(contact.googleRating) && contact.googleRating >= 1 && contact.googleRating <= 5) {
    preview.googleRating = contact.googleRating;
  }
  if (Number.isInteger(contact.googleRatingCount) && contact.googleRatingCount >= 0 && contact.googleRatingCount <= 100_000_000) {
    preview.googleRatingCount = contact.googleRatingCount;
  }
  return preview;
}
